<template>
  <div class="diaglog-wrapper">
    <div class="dialog-container order-detail-dialog">
      <div class="order-detail-dialog-container">
        <p class="dialog-title">{{ letter.order_detail }}</p>
        <div class="detail">
          <div
            class="detail-item"
            v-for="(item, index) in cartList"
            :key="index"
          >
            <div class="name">{{ item.productDesc }}</div>
            <div class="num">
              {{ letter.total_detail
              }}<span class="num-quantity">{{ item.quantity }}</span>
            </div>
            <div class="total-wrap">
              <span class="total"> {{ letter.storeTotal }}：</span>
              {{ itemTotalPrice(+item.amount, +item.quantity) }}
              {{ currency }}
            </div>
          </div>
          <div v-if="cartTotalProductExtraCoin" class="detail-item">
            <div class="name extra">{{ v3FirstTopUpGiveaway }}:</div>
            <div class="total-wrap extra">
              <span class="num">{{ cartTotalProductExtraCoin }}</span
              >{{ coinName }}
            </div>
          </div>
          <div v-if="cartTotalIngameLimitedExtraCoin > 0" class="detail-item">
            <div class="name extra">{{ ingameLimitedText }}:</div>
            <div class="total-wrap extra">
              <span class="num">{{ cartTotalIngameLimitedExtraCoin }}</span
              >{{ ingameLimitedExtraCoinName }}
            </div>
          </div>
          <div class="detail-item">
            <div class="name extra">{{ letter.storeExtra }}:</div>
            <div class="total-wrap extra">
              <span class="num">{{ totalExtra }}</span
              >{{ coinName }}
            </div>
          </div>
        </div>
      </div>
      <Icon class="close-btn" name="close" @click="close" />
    </div>
  </div>
</template>
<script>
import { times, plus } from '@utiles/officialStore/index';
import ingameLimitedExtra from '@mixins/officialTopupNew/ingameLimitedExtra';
export default {
  mixins: [ingameLimitedExtra],
  props: [
    'cartList',
    'currency',
    'coinName',
    'cartTotalProductExtraCoin',
    'cartTotalIngameLimitedExtraCoin',
    'ingameLimitedExtraCoinName'
  ],
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    totalExtra() {
      let totalExtra = 0;
      this.cartList.forEach(item => {
        totalExtra = plus(totalExtra, times(+item.extraCoin, +item.quantity));
      });
      return totalExtra;
    },
    v3FirstTopUpGiveaway() {
      return this.letter.v3FirstTopUpGiveaway?.replace?.('\n', '') || '';
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    itemTotalPrice(amount, quantity) {
      return times(+amount, +quantity);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
@import '@assets/scss/officialTopupNew/common.scss';
.order-detail-dialog {
  padding: 0;
  width: 720px;
}
.order-detail-dialog-container {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background-color: #ffffff;
}
.title {
  margin: 43px auto 32px;
  text-align: center;
  font-weight: bolder;
  font-size: 48px;
}
.detail {
  overflow-y: scroll;
  box-sizing: border-box;
  height: 400px;
  margin: 0 10px;
  padding: 0 30px 30px;
  font-size: 24px;

  &-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 24px 0;
    border-bottom: 1px solid #666;
    .name {
      &.extra {
      }
    }
    .num {
      margin: 8px 0;
      &-quantity {
      }
    }
    .total-wrap {
      font-weight: bold;
      .total {
      }
      &.extra {
        .num {
          font-size: 34px;
        }
      }
    }
  }
}

#ssr-page.landscape {
  .order-detail-dialog {
    background-size: cover;
  }
  .title {
    margin: 53px auto 20px;
    font-size: 30px;
  }
  .detail {
    font-size: 16px;
  }
}
</style>
